export default {
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 10px 0 10px',
    gap: '4px',
    minHeight: '40px',
    borderBottom: (theme) => `1px solid ${theme.palette.grays.gray200}`,
    borderTop: 'none',
    backgroundColor: (theme) => theme.palette.background.paper,
  },
  toolbarWithViewModes: {
    padding: '0 10px 0 0',
  },
  searchField: {
    width: '100%',
    border: 'none',
    paddingLeft: '0',
    '& .MuiOutlinedInput-root': {
      height: '32px',
      fontSize: '14px',
      backgroundColor: 'transparent',
      '& fieldset': { border: 'none' },
    },
    '& .MuiInputBase-root': {
      pl: 0,
    },
  },
  filterMenu: {
    minWidth: '280px',
    maxWidth: '320px',
  },
  filterMenuHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    borderBottom: (theme) => `1px solid ${theme.palette.grays.gray150}`,
  },
  filterMenuTitle: {
    fontWeight: 600,
    fontSize: '14px',
  },
  filterMenuContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    padding: '16px',
  },
  filterMenuActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    justifyContent: 'flex-end',
  },
  viewButtonGroup: {
    '& .MuiToggleButton-root.Mui-selected': {
      padding: '8px',
      border: 'none',
      color: (theme) => theme.palette.blues.primaryBlue500,
      fill: (theme) => theme.palette.blues.primaryBlue500,
      background: (theme) => theme.palette.blues.lightestBlue,
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays.lightestGray,
        transition: `background-color 2ms linear`,
      },
      path: {
        fill: (theme) => theme.palette.blues.primaryBlue500,
      },
    },
    '& .MuiToggleButton-root:first-of-type': {
      borderTopLeftRadius: 2,
      borderLeft: 'none',
      borderTop: 'none',
      borderBottom: 'none',
      borderRight: (theme) => `1px solid ${theme.palette.grays.gray300}`,
      borderBottomLeftRadius: 0,
    },
    '& .MuiToggleButton-root:last-of-type': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderTop: 'none',
      borderBottom: 'none',
      borderRight: 'none',
    },
  },
};
